import { gql } from "@apollo/client";

export const savedFiltersFieldsFragment = gql`
  fragment SavedFiltersFields on MainTab {
    savedFilters {
      filterValue
    }
  }
`;
